import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { theme } from '../../constants'
import { StyleProps } from '../../utils'
import { Div } from '../Div'

const Root = styled(Div)({
  gridArea: 'Body',
  padding: `0px ${theme.spacing[3]}px ${theme.spacing[2]}px`,
})

export const Body = ({
  grow = false,
  children,
  styles,
}: {
  styles?: StyleProps
  grow?: boolean
  children: ReactNode
}) => {
  const mergedStyles: StyleProps = {
    ...(grow
      ? { flex: 1 }
      : {
          minHeight: 60,
          overflowY: 'auto',
          maxHeight: '70vh',
        }),
    ...styles,
  }

  return <Root styles={mergedStyles}>{children}</Root>
}
